// extracted by mini-css-extract-plugin
export const ourArticles = "styles-module--ourArticles--wSX3m";
export const allArticles = "styles-module--allArticles--1qjft";
export const hidden = "styles-module--hidden--21II3";
export const toggleView = "styles-module--toggleView--3DTvf";
export const blueArticles = "styles-module--blueArticles--2CAzo";
export const questionIcon = "styles-module--questionIcon--2JDA1";
export const articleColumns = "styles-module--articleColumns--F54al";
export const list = "styles-module--list--2auO7";
export const title = "styles-module--title--2mTe4";